import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  GridItem,
  Heading,
  Icon,
  IconButton,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { BsWhatsapp } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import {
  SiMongodb,
  SiMysql,
  SiNestjs,
  SiNextdotjs,
  SiPostgresql,
  SiTypescript,
  SiGit,
  SiExpress,
  SiFirebase,
  SiRedux,
  SiDocker,
} from "react-icons/si";
import { FaNodeJs, FaReact, FaAws } from "react-icons/fa";

const Home = () => {
  const skills = [
    {
      name: "React.js",
      icon: FaReact,
      link: "https://reactjs.org/",
      description: "A JavaScript library for building user interfaces",
    },
    {
      name: "React Native",
      icon: FaReact,
      link: "https://reactnative.dev/",
      description:
        "JavaScript framework for writing real, natively rendering mobile applications for iOS and Android.",
    },
    {
      name: "Node.js",
      icon: FaNodeJs,
      link: "https://nodejs.org/",
      description: "Chrome's V8 JavaScript engine for server-side javascript.",
    },
    {
      name: "NestJS",
      icon: SiNestjs,
      link: "https://nestjs.com/",
      description:
        "A progressive Node.js framework for building efficient, reliable and scalable server-side applications.",
    },
    {
      name: "TypeScript",
      icon: SiTypescript,
      link: "https://www.typescriptlang.org/",
      description:
        "Strongly typed programming language that builds on JavaScript, giving you better tooling at any scale.",
    },
    {
      name: "AWS",
      icon: FaAws,
      link: "https://aws.amazon.com/",
      description:
        "Platform that offers flexible, reliable, scalable, easy-to-use and, cost-effective cloud computing solutions.",
    },
    {
      name: "PostgreSQL",
      icon: SiPostgresql,
      link: "https://www.postgresql.org/",
      description: "Powerful, open source object-relational database system.",
    },
    {
      name: "MySQL",
      icon: SiMysql,
      link: "https://www.mysql.com/",
      description: "Open Source SQL database management system.",
    },
    {
      name: "MongoDB",
      icon: SiMongodb,
      link: "https://www.mongodb.com/",
      description:
        "Document database with the scalability and flexibility that you want with the querying and indexing that you need.",
    },
    {
      name: "NextJS",
      icon: SiNextdotjs,
      link: "https://nextjs.org/",
      description:
        "Hybrid static & server rendering, TypeScript support, smart bundling, route pre-fetching, and more.",
    },
    {
      name: "Git",
      icon: SiGit,
      link: "https://git-scm.com/",
      description:
        "Version control system designed to handle everything from small to very large projects with speed and efficiency.",
    },
    {
      name: "Express",
      icon: SiExpress,
      link: "https://expressjs.com/",
      description: "Fast, unopinionated, minimalist web framework for Node.js.",
    },
    {
      name: "Firebase",
      icon: SiFirebase,
      link: "https://firebase.google.com/",
      description: "Firebase helps you build and run successful apps.",
    },
    {
      name: "Redux",
      icon: SiRedux,
      link: "https://redux.js.org/",
      description: "A Predictable State Container for JS Apps.",
    },
    {
      name: "Docker",
      icon: SiDocker,
      link: "https://www.docker.com/",
      description:
        "Takes away repetitive, mundane configuration tasks and is used throughout the development lifecycle.",
    },
  ];
  return (
    <Container maxW={"container.lg"}>
      <Heading size={"2xl"}>Hey , I’m Nicolas Peralta</Heading>
      <Heading size="lg" fontWeight={"normal"} color={"gray.500"} mt={5}>
      <Text as={"span"} color={"purple.500"}>Senior software engineer</Text> specialized in web applications, proficient in both frontend and backend development, as well as skilled in creating and managing infrastructures.
      </Heading>

      <Stack direction={["column", "row"]} spacing={3} mt={10}>
        <Button
          as={"a"}
          href={"mailto:nicoperalta1998@gmail.com"}
          leftIcon={<Icon as={MdEmail} />}
          colorScheme="purple"
          variant="solid"
        >
          nicoperalta1998@gmail.com
        </Button>
        <Button
          as={"a"}
          href={"https://wa.me/543472435518"}
          target="_blank"
          leftIcon={<Icon as={BsWhatsapp} />}
          colorScheme="purple"
          variant="solid"
        >
          WhatsApp
        </Button>
      </Stack>
      <Divider my={10} />
      <Heading size={"xl"}>Primary Stack & Technologies</Heading>
      <Heading
        size="md"
        fontWeight={"normal"}
        color={"gray.500"}
        mt={5}
        mb={10}
      >
        As a full-stack web and mobile developer there are alot of tools you use
        in your daily bases, these are primary tools that i use & like.
      </Heading>
      <Grid templateColumns="repeat(6, 1fr)" gap={6}>
        {skills.map((skill) => (
          <GridItem
            colSpan={[6, 3, 2]}
            key={skill.name}
            border={"1px solid"}
            borderColor={"gray.600"}
            borderRadius={"md"}
            display={"flex"}
            p={5}
            role="group"
            _hover={{
              borderColor: "purple.500",
            }}
            cursor={"default"}
            userSelect="none"
          >
            <IconButton
              as={Link}
              href={skill.link}
              target={"_blank"}
              _groupHover={{ color: "purple.400" }}
              variant={"ghost"}
              isActive
              aria-label="Change theme color"
              icon={<Icon as={skill.icon} />}
            />
            <Box ml={5}>
              <Heading size={"sm"}>{skill.name}</Heading>
              <Text fontSize="sm" opacity={0.6}>
                {skill.description}
              </Text>
            </Box>
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
};

export default Home;
